import { ContentContainerMax } from '../../../layout/container';
import styled from '@emotion/styled';
import {
  mediaQueries,
  spacingTop,
} from '@digando/react-component-library';
import React, { FC } from 'react';
import { ComponentContentUspProduct } from '../../../@types/codegen/graphql';
import { ProductBenefits } from '@digando/common-ui';

type UspProductProps = ComponentContentUspProduct & { sliceIndex: string };

const UspProduct: FC<UspProductProps> = ({ usps }) => {
  return (
    <UspSectionWrapper>
      <ContentContainerMax>
        <ProductBenefits
          benefits={usps?.map((usp) => usp?.advantage ?? '') ?? []}
          availableProducts={0}
          availabilityText={''}
          isDeliverable={false}
          deliveryText={''}
        />
      </ContentContainerMax>
    </UspSectionWrapper>
  );
};

const UspSectionWrapper = styled.div`
  ${spacingTop(5)};
  text-align: right;

  @media ${mediaQueries.tablet} {
    ${spacingTop(2)};
  }
`;

export default UspProduct;
